import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';

import { selectLibrarySummary, selectFavoritesSummary } from './redux/selectors';

import Immutable from 'immutable';
import VideoTile from './common/VideoTile';
import Icon from '../../common/icons/Icon';

class CategoryListPage extends Component {
  static propTypes = {
    categorySummaries: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      searchQuery: '',
    };
  }

  handleSearchQueryChange = e => {
    const searchQuery = e.target.value;
    this.setState(state => ({ searchQuery }));
  };

  renderSearchResults() {
    const { categories, favorites } = this.props;
    const { searchQuery } = this.state;

    const loweredSearchQuery = searchQuery.toLowerCase();

    const relevantFavorites = favorites
      .get('data')
      .filter(record => {
        if (record.has('tvEpisode')) {
          return (
            (record.getIn(['tvEpisode', 'name']) || '').toLowerCase().includes(loweredSearchQuery) ||
            (record.getIn(['tvEpisode', 'description']) || '').toLowerCase().includes(loweredSearchQuery)
          );
        }
        return false;
      })
      .map(record =>
        record
          .get('tvEpisode')
          .set('categoryId', 'favorites')
          .set('id', record.get('id'))
          .set('user_eligible', true)
      );

    const relevantLibraryContent = categories
      .get('data')
      .reduce((acc, category) => acc.concat(category.get('sections')), new Immutable.List())
      .reduce((acc, section) => {
        return acc.concat(
          section
            .get('libraryRecords')
            .filter(record => {
              return (
                record
                  .get('name')
                  .toLowerCase()
                  .indexOf(loweredSearchQuery) >= 0 ||
                (record.get('description') &&
                  record
                    .get('description')
                    .toLowerCase()
                    .indexOf(loweredSearchQuery) >= 0)
              );
            })
            .map(record => record.set('categoryId', section.get('library_category_id')))
        );
      }, new Immutable.List());

    const relevantRecords = relevantFavorites.concat(relevantLibraryContent);

    if (!relevantRecords.size) {
      return <div> No videos match the search query </div>;
    }

    const renderedVideos = relevantRecords.map(record => (
      <VideoTile
        locked={!record.get('user_eligible') && !record.get('show_id')}
        key={record.get('id')}
        videoLocation={`/subscription/library/${record.get('categoryId')}/videos/${record.get('id')}`}
        video={record}
        categoryId={record.get('categoryId')}
      />
    ));

    return (
      <div className="lib-cat--section">
        <div className="lib-cat--video-list">{renderedVideos}</div>
      </div>
    );
  }

  renderCategories() {
    const { categorySummaries, favoritesSummary } = this.props;

    return categorySummaries.insert(0, favoritesSummary).map(categorySummary => {
      return (
        <Link
          to={`/subscription/library/${categorySummary.get('id')}`}
          className="category-card"
          key={categorySummary.get('id')}
        >
          <div
            className="img-wrapper"
            style={{
              backgroundImage: `url(${categorySummary.get('imageSrc')})`,
            }}
          >
          { categorySummary.get('isCourse') &&
            <span className="course">
              <i className="fas fa-book"></i>&nbsp; 
              Course Content
            </span>
          }
          </div>
          <div className="category-card--info">
            <h3>{categorySummary.get('name')}</h3>
            <p>{categorySummary.get('recordCount')} Videos</p>
          </div>
        </Link>
      );
    });
  }

  render() {
    const pageContent = this.state.searchQuery.length ? (
      this.renderSearchResults()
    ) : (
      <div className="category-list">{this.renderCategories()}</div>
    );

    return (
      <div className="lib-wrapper">
        <div className="lib__header">
          <h2>Library</h2>
          <div className="lib--search__wrapper">
            <Icon icon="Search" />
            <input
              className="lib--search"
              type="text"
              placeholder="Search..."
              onChange={this.handleSearchQueryChange}
              value={this.state.searchQuery}
            />
          </div>
        </div>
        {pageContent}
      </div>
    );
  }
}

const mapStateToProps = state => {
  const categories = state.subscription.library.categories;
  const favorites = state.subscription.favorites.favorites;

  return {
    categories,
    categorySummaries: selectLibrarySummary(categories, favorites),
    favorites,
    favoritesSummary: selectFavoritesSummary(favorites),
  };
};

export default connect(mapStateToProps)(withRouter(CategoryListPage));



// WEBPACK FOOTER //
// ./src/subscription/library/CategoryListPage.jsx